/**
 * Ce fichier permets d'afficher la positions en réel sous forme d'un cercle
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/
import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { map } from './Map';
import { selectSession } from '../createSelectorUtils';

/*-------------------------------------------------------------------------------------------*/

export default function AddIcaoView() {
  const session = useSelector(selectSession);

  const id = 'icao';
  useEffect(() => {
    if (map.getSource(id) === undefined) {
      map.addSource(id, {
        type: 'raster',
        tiles: [
          'https://wxs.ign.fr/p6fcc2eai88nlz5m8nz1i5y0/geoportail/wmts?layer=GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-OACI&style=normal&tilematrixset=PM&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'
        ],
        tileSize: 256
      });
    }

    map.addLayer({
      id: 'icao-layer',
      type: 'raster',
      source: id,
      minzoom: 6,
      maxzoom: 11,
      layout: {
        visibility:
          (session.attributes && session.attributes.icaoView ? 'visible' : 'none') || 'visible'
      }
    });

    if (session.attributes && session.attributes.icaoView) {
      map.easeTo({ zoom: 10.8 });
    }

    return () => {
      if (map.getLayer('icao-layer')) {
        map.removeLayer('icao-layer');
      }
    };
  }, [session.attributes]);

  return null;
}
